import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { History, RotateCcw } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { fmtWhen, useAdmin } from "./ui";

export const ContentHistory = ({ onRestored }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState("");
  const { data } = useAdmin("content-history", "/admin/content/history");
  const qc = useQueryClient();
  const restore = async (v) => {
    if (!window.confirm(`Restore the site content saved ${fmtWhen(v.saved_at)}? Your current version is kept in history too.`)) return;
    setBusy(v.id);
    try {
      const { data: saved } = await api.post(`/admin/content/history/${v.id}/restore`);
      qc.setQueryData(["content"], saved);
      qc.invalidateQueries({ queryKey: ["admin", "content-history"] });
      onRestored(saved);
      toast.success("Previous version restored — live now");
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(""); }
  };
  return (
    <div className="ad-card" data-testid="content-history">
      <button type="button" className="ad-section-head" onClick={() => setOpen(!open)} aria-expanded={open} data-testid="content-history-toggle">
        <span><History size={16} /> Version history {data?.length ? `(${data.length})` : ""}</span>
      </button>
      {open && (
        <div className="ch-list">
          <p className="muted-sm">A copy is saved automatically every time content changes. Restore any earlier version in one tap.</p>
          {!data?.length && <p className="muted-sm" data-testid="content-history-empty">No earlier versions yet.</p>}
          {data?.map((v) => (
            <div className="ad-row" key={v.id} data-testid={`content-version-${v.id}`}>
              <span>{fmtWhen(v.saved_at)} <small className="muted-sm">· {v.note}{v.saved_by && ` · ${v.saved_by}`}</small></span>
              <button type="button" className="btn light" disabled={!!busy} onClick={() => restore(v)} data-testid={`content-version-restore-${v.id}`}>
                <RotateCcw size={14} /> {busy === v.id ? "Restoring…" : "Restore"}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
